var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.0001C-1.186 7.81308 -0.889997 3.13408 1.94 1.01208L2.567 0.545077C2.72698 0.427374 2.90897 0.343003 3.10217 0.296972C3.29537 0.25094 3.49585 0.244186 3.69172 0.27711C3.88758 0.310033 4.07483 0.381964 4.24237 0.488634C4.4099 0.595303 4.5543 0.734538 4.667 0.898077L6.246 3.17008C6.45729 3.47415 6.54865 3.84562 6.5025 4.213C6.45635 4.58039 6.27594 4.91772 5.996 5.16008L4.476 6.47408C4.096 6.80308 3.91 7.30208 4.081 7.77508C4.397 8.65508 5.164 10.2081 6.978 12.0211C8.792 13.8351 10.344 14.6021 11.224 14.9191C11.698 15.0891 12.197 14.9041 12.526 14.5231L13.84 13.0051C14.0824 12.7251 14.4197 12.5447 14.7871 12.4986C15.1545 12.4524 15.5259 12.5438 15.83 12.7551L18.106 14.3351C18.2694 14.4474 18.4085 14.5914 18.5152 14.7586C18.6218 14.9257 18.6938 15.1126 18.7268 15.3081C18.7598 15.5036 18.7532 15.7038 18.7074 15.8967C18.6615 16.0896 18.5774 16.2713 18.46 16.4311L17.99 17.0641C15.869 19.8921 11.188 20.1871 5 14.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.ba5c0298caa8506c6831cb1237274105.svg";
export { ForwardRef as ReactComponent };